export * from './profiles.page';
export * from './contact-detail.page';

